import api from '@/modules/api'
import { AxiosResponse } from 'axios'
import {IApiResponse} from '@/common/models/interface'
import {
  RenewalPaymentOptionPatchParam,
  SubscriptionParam,
  SubscriptionRsp,
  SubscriptionOrderCheckoutParam,
  SubscriptionOrderCheckoutRsp,
  SubscriptionGetRsp,
} from '@/services/models/Subscription'

export default class SubscriptionService{

  /**
   * Patch a PaymentOption
   *
   * @returns {Promise<any>}
   * @memberof Subscription
   */
  public async patchRenewalPaymentOption(payload: RenewalPaymentOptionPatchParam): Promise<IApiResponse<any>> {
    const res: AxiosResponse = await api.patch('Subscription/RenewalPaymentOption', payload)
    return res.data
  }

  /*
  * Preview the payment status of an upgrade
  * */
  public async previewUpgradePayment(planId: string, paymentOptionId: string)
    : Promise<any> {
    return api.get(`Subscription/UpgradeInfo/${planId}/${paymentOptionId}`)
  }

  /*
  * retrieve a subscription by id
  * */
  public async get(id: string) : Promise<SubscriptionGetRsp> {
    return api.get(`Subscription/${id}`)
  }

  public async post(payload: SubscriptionParam): Promise<any> {
    return api.post('Subscription', payload)
  }

  public async patch(payload: SubscriptionParam): Promise<IApiResponse<SubscriptionRsp>> {
    const res: AxiosResponse = await api.patch('Subscription', payload)
    return res.data
  }

  public async orderCheckout(payload: SubscriptionOrderCheckoutParam): Promise<IApiResponse<SubscriptionOrderCheckoutRsp>> {
    const res: AxiosResponse = await api.post('Subscription/OrderCheckout', payload)
    return res.data
  }

  public async cancel(): Promise<IApiResponse<any>> {
    const res: AxiosResponse = await api.patch('Subscription/Cancel')
    return res.data
  }
}
